"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var EventBusy_exports = {};
__export(EventBusy_exports, {
  default: () => EventBusy_default
});
module.exports = __toCommonJS(EventBusy_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00001 2.40015C8.33138 2.40015 8.60001 2.66878 8.60001 3.00015V4.00024H15.4V3.00015C15.4 2.66878 15.6686 2.40015 16 2.40015C16.3314 2.40015 16.6 2.66878 16.6 3.00015V4.00024H19C20.1046 4.00024 21 4.89567 21 6.00024V19.0002C21 20.1048 20.1046 21.0002 19 21.0002H5C3.89543 21.0002 3 20.1048 3 19.0002V6.00024C3 4.89567 3.89543 4.00024 5 4.00024H7.40001V3.00015C7.40001 2.66878 7.66864 2.40015 8.00001 2.40015ZM15.4 5.00024V6.00015C15.4 6.33152 15.6686 6.60015 16 6.60015C16.3314 6.60015 16.6 6.33152 16.6 6.00015V5.00024H19C19.5523 5.00024 20 5.44796 20 6.00024V8.00024L4 8.00024L4 6.00024C4 5.44796 4.44772 5.00024 5 5.00024H7.40001V6.00015C7.40001 6.33152 7.66863 6.60015 8.00001 6.60015C8.33138 6.60015 8.60001 6.33152 8.60001 6.00015V5.00024H15.4ZM4 9.00024V19.0002C4 19.5525 4.44772 20.0002 5 20.0002H19C19.5523 20.0002 20 19.5525 20 19.0002V9.00024L4 9.00024Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.8991 12.3992C15.1334 12.1648 15.1334 11.7849 14.8991 11.5506C14.6648 11.3163 14.2849 11.3163 14.0506 11.5506L11.9999 13.6013L9.9494 11.5507C9.71508 11.3164 9.33518 11.3164 9.10087 11.5507C8.86655 11.7851 8.86655 12.1649 9.10087 12.3993L11.1514 14.4498L9.10086 16.5004C8.86654 16.7347 8.86654 17.1146 9.10086 17.3489C9.33517 17.5832 9.71507 17.5832 9.94939 17.3489L11.9999 15.2983L14.0506 17.349C14.2849 17.5833 14.6648 17.5833 14.8991 17.349C15.1335 17.1147 15.1335 16.7348 14.8991 16.5005L12.8485 14.4498L14.8991 12.3992Z",
      fill: "currentColor"
    }
  )
);
const SvgEventBusy = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var EventBusy_default = SvgEventBusy;
